import { useUtmStore } from "~/stores/useUtmStore";

import { UTM_PARAMS } from "./constants";
import { isLogoutReferralCleanupActive } from "./logoutReferralCleanup";
import {
  isValidShareId,
  SHARE_ACTION_SOURCE,
  SHARE_ID_PARAM,
  SHARE_SOURCE_PARAM,
  URL_COPY_SOURCE,
} from "./share-attribution";

function getTrackedSearchParams(url: URL) {
  const paramsToAdd: Record<string, string> = {};

  UTM_PARAMS.forEach((param) => {
    const value = url.searchParams.get(param);
    if (param === SHARE_ID_PARAM && !isValidShareId(value)) {
      return;
    }
    if (param === SHARE_SOURCE_PARAM && value !== SHARE_ACTION_SOURCE && value !== URL_COPY_SOURCE) {
      return;
    }
    if (value) {
      paramsToAdd[param] = value;
    }
  });

  return paramsToAdd;
}

export function captureUtm() {
  const url = new URL(window.location.href);

  if (isLogoutReferralCleanupActive(url)) {
    useUtmStore.getState().clearUtmData();
    localStorage.removeItem("twi.utmDataStore");
    return;
  }

  const paramsToAdd = getTrackedSearchParams(url);

  if (Object.keys(paramsToAdd).length > 0) {
    useUtmStore.getState().setUtmData(paramsToAdd);
  }
}

export function clearCapturedUtm() {
  useUtmStore.getState().clearUtmData();

  const url = new URL(window.location.href);
  const trackedParams = getTrackedSearchParams(url);

  if (Object.keys(trackedParams).length === 0) {
    return;
  }

  UTM_PARAMS.forEach((param) => {
    url.searchParams.delete(param);
  });

  const nextUrl = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState(window.history.state, "", nextUrl);
}
